import { Constraint, ConstraintArg, SampleConditionConstraint } from "types";

import { ConstraintTerms } from "consts";

const formatArg = (arg: ConstraintArg): SampleConditionConstraint => {
  const { type, uuid, a, answers, dateFilter } = arg;

  const value = answers?.v ?? [];

  switch (type) {
    case ConstraintTerms.SEG:
      if (!uuid) throw new Error("SEG constraint requires a uuid");
      return { type, uuid };

    case ConstraintTerms.ATT:
      return { type, a, dateFilter, v: value };

    case ConstraintTerms.GEO:
    case ConstraintTerms.ZIP:
      return { type: ConstraintTerms.ATT, a, v: value };

    default:
      throw new Error(`Unsupported constraint type: ${type}`);
  }
};

const formatConstraints = (constraints: Constraint[]) =>
  constraints.map(({ type, args }) => ({
    type,
    args: args.map(formatArg),
  }));

export default formatConstraints;
